import { getSilentAuth } from './silentAuth';
export function login(client, continueTo) {
    const silentAuth = getSilentAuth(client);
    silentAuth.login({
        redirectUri: continueTo,
    });
}
export function logout(client, continueTo = 'https://artists.spotify.com/home') {
    const silentAuth = getSilentAuth(client);
    silentAuth.logout(continueTo);
}
//# sourceMappingURL=accounts.js.map